import axios from 'axios'

export const getParcelCalculusData = async (item: any, url: string) => {
  try {
    const body = { inputs: item }
    const { data } = await axios.post(url, body)
    for (const res of data) {
      const response = res?.response
      if ('Errors' in response) {
        let errors = ''
        for (const property in response?.Errors) {
          errors += `${property}: ${response?.Errors[property]}.`
        }
        const error = { error: errors, isError: true }
        error['error'] = error.error === '' ? 'Api Failed' : error.error
        response['error'] = error
        data['response'] = response
      }
    }
    return data
  } catch (e) {
    let errors = ''
    for (const property in e?.response?.data?.errors) {
      errors += `${property}: ${e?.response?.data?.errors[property]}.`
    }
    const error = { error: errors, isError: true }
    error['error'] = error.error === '' ? 'Api Failed' : error.error
    return error
  }
}
